// src/plugins/authPlugin.js
import { ref } from 'vue'

export default {
  install(app) {
    const permissions = ref(JSON.parse(localStorage.getItem('permissions') || '[]'))

    const setPermissions = (perms) => {
      permissions.value = perms          // update reactive state
      localStorage.setItem('permissions', JSON.stringify(perms))
    }

    const hasPermission = (perm) => permissions.value.includes(perm)

    const auth = {
      permissions,
      hasPermission,
      setPermissions
    }

    app.provide('auth', auth)
    app.config.globalProperties.$auth = auth
  }
}
